import { Form, Select, Tabs, Typography } from 'antd'

import { CHARGE_SCOPES, SCOPE_LABEL } from '../charges/chargeScope'
import { type BusinessFilters as Filters, PERIODS } from '../useBusinessFilters'
import type { ChargeWindow } from '../useBusinessQueries'

const SCOPE_HINT = {
  customers: 'Accounts outside internal groups; unidentified accounts included',
  internal: 'Internal groups: our own usage, not revenue',
  all: 'Every account; internal ones are tagged',
} as const

/** Whose money the page shows, then the period and chart step of the charges. */
export function BusinessFilters({
  filters,
  onChange,
}: {
  filters: Filters
  onChange: (patch: Partial<Filters>) => void
}) {
  return (
    <>
      <Tabs
        activeKey={filters.scope}
        onChange={(key) => onChange({ scope: key as Filters['scope'] })}
        items={CHARGE_SCOPES.map((scope) => ({
          key: scope,
          label: SCOPE_LABEL[scope],
        }))}
      />
      <Typography.Paragraph type="secondary" style={{ marginTop: -8 }}>
        {SCOPE_HINT[filters.scope]}
      </Typography.Paragraph>
      <Form layout="inline" style={{ marginBottom: 16, rowGap: 8 }}>
        <Form.Item label="Period">
          <Select
            aria-label="Period"
            style={{ width: 150 }}
            value={filters.days}
            onChange={(days) => onChange({ days })}
            options={PERIODS.map((days) => ({
              label: `Last ${days} days`,
              value: days,
            }))}
          />
        </Form.Item>
        <Form.Item label="Chart step">
          <Select<ChargeWindow>
            aria-label="Chart step"
            style={{ width: 120 }}
            value={filters.window}
            onChange={(window) => onChange({ window })}
            options={[
              { label: 'Day', value: 'DAY' },
              { label: 'Month', value: 'MONTH' },
            ]}
          />
        </Form.Item>
      </Form>
    </>
  )
}
